export default "/images/vendor/@coreui/icons/svg/flag/cif-mh.svg?34fe4054380c1015959fb0b5a24f806b";